import { FC, useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import GenericError from '@/components/Error/GenericError';

import { XpApiError } from '@/services/api-types';

import PageNotFound404 from '@/routes/404/404';

interface DocumentErrorProps {
  error?: XpApiError;
  otherError?: object;
  documentId: string;
}

const DocumentError: FC<DocumentErrorProps> = ({
  error,
  otherError,
  documentId,
}) => {
  useEffect(() => {
    if (error) {
      datadogRum.addError(error);
    }
    if (otherError) {
      datadogRum.addError(
        new Error(JSON.stringify({ ...otherError, documentId })),
      );
    }
  }, [documentId, error, otherError]);

  switch (error?.status ?? otherError) {
    case 404:
      return <PageNotFound404 />;
    default:
      return <GenericError />;
  }
};

export default DocumentError;
